module.exports = __webpack_public_path__ + "static/media/golfplus.76c4cdd3.png";